// extracted by mini-css-extract-plugin
export default {"card":"NoOrderHistoryCard_card__q0w64","icon":"NoOrderHistoryCard_icon__eBKPd","text":"NoOrderHistoryCard_text__hau7s","link":"NoOrderHistoryCard_link__QVuox"};